import { API } from "aws-amplify";
import sanitizeHtml from "sanitize-html";

export function getSettings(key = "config") {
  return API.get("settings", `settings/${key}`);
}

export function updateSettings(key, values) {
  return API.put("settings", `settings/${key}`, { body: values });
}

//Training-data related functionality is inserted here
//for simplicity sake (i.e. not to deal with authorization, permission details)
//they can be placed in a separate file
export function insertTrainingData(values) {
  //apply value transformation:
  if (values.title) values.title = cleanText(values.title);
  if (values.text) values.text = cleanText(values.text);

  return API.post("settings", "training-data", { body: values });
}
/**
 * returns all tagged training data if  tagged is true
 * returns all untagged training data if tagged is false
 * @param {*} tagged
 */
export function getTrainingData(tagged = true) {
  return API.get("settings", `training-data?tagged=${tagged}`);
}

export function updateTrainingData(values) {
  return API.put("settings", "training-data", { body: values });
}

export function deleteTrainingData(dataId) {
  return API.del("settings", `training-data/${dataId}`);
}

function cleanText(text) {
  //for better readability, try to keep newlines

  return sanitizeHtml(
    text
      .replace(/<\/p>/gi, "</p>\n")
      .replace(/<\/div>/gi, "</div>\n")
      .replace(/<br>/gi, "<br>\n"),
    {
      allowedTags: [],
      allowedAttributes: {},
    }
  ); //.replace(/\r?\n/g, "");
}
